<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            @click="createBean"
            >{{ $t("m.options.listTab.new") }}</el-button
          >
        </div>
      </div>
      <!--内容-->
      <div style="max-height:calc(100% - 83px); gap: 15px; display: flex; flex-direction: column;">
        <div
          class="box-content"
          v-if="active == 1"
        >
          <div
            @click="checkDevice(item)"
            :class="[
              item.id == activeBeanId
                ? 'box-item box-half box-active'
                : 'box-item box-half',
            ]"
            v-for="item in beanList"
            v-bind:key="item.id"
          >
            <div class="box-item-text">
              <div>
                <span class="text-title">{{ $t("m.commentDetail.name") }}：</span>
                <span class="text-value">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
        layout="prev, pager, next" 
        background
        align="right"
        :page-size="beanPage.pageSize" 
        :page-count="beanPage.pageNum" 
        :total="beanPage.total"  
        @current-change="beanPageChange"/>

      </div>
    </div>
    <div class="main-box border-1px-all">
      <bean-detail
        v-if="refreshBeanDetail"
        :beanInfo="selectBean"
        :show-report-list="showReportList"
        :isAdd="isAdd"
      ></bean-detail>
    </div>
  </div>
</template>

<script>
//import beanDetail from '@/components/bean/beanDetail'
import beanDetail from "@/components-online/setting/typeDetail";

export default {
  name: "storageStatus",
  components: {
    "bean-detail": beanDetail,
  },
  data() {
    return {
      weight: "kg",
      isAdd: false,
      beanList: [],
      beanPage: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
      },
      beanKindCount: 0,
      beanAllWeight: 0,
      hasSearchParams: false,
      url: "/manage/deviceType/list.do",
      searchParamValue: "", //搜索框输入的值
      searchParamKey: "name",
      searchParamsKeyOptions: [
        { value: "name", label: "生豆名称" },
        { value: "supply", label: "供应商" },
      ],
      orderParamValue: "", //搜索框输入的值
      orderParamKey: "/manage/bean/listByName.do",
      orderParamsKeyOptions: [
        { value: "/manage/bean/listByName.do", label: "首字母" },
        { value: "/manage/bean/listByStock.do", label: "库存" },
        { value: "/manage/bean/listByTime.do", label: "创建时间" },
      ],
      beanCountUrl: "/manage/bean/count.do",
      beanDetailDialog: false,
      selectBean: {},
      showReportList: false,
      refreshBeanDetail: true,
      selectBeanIds: [],
      activeBeanId: 0,
      loading: undefined,

      active: 1,
      active1: 1,
      bean: "",
      deal: "",
      level: "",
      season: "",
      name: "",
      date: "",
      selectValue: "",
      sliderValue: 30,
      num1: 3,
      num2: 0,
      num3: 0,
      dialogTableVisible: false,
      dialogTableVisible2: false,
    };
  },
  mounted() {
    this.getBeanList();
  },
  methods: {
    createBean() {
      this.isAdd = true;
      this.showReportList = false;
      this.selectBean = {};
      this.refreshBeanDetail = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshBeanDetail = true;
      });
    },
    getBeanList() {
      this.$http
        .get(this.url, {
          params: {
            pageNum: this.beanPage.pageNum,
            pageSize: this.beanPage.pageSize,
          },
        })
        .then(
          function(resp) {
            this.beanList = resp.data.data.list;
            this.beanPage.total = resp.data.data.total;

            this.activeBeanId = resp.data.data.list[0].id;

            this.selectBean = this.beanList[0];
            this.selectBean.owner = -1;
            this.showReportList = true;
            this.refreshBeanDetail = false;
            this.isAdd = false;
            // 在组件移除后，重新渲染组件
            // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            this.$nextTick(() => {
              this.refreshBeanDetail = true;
            });
            this.beanDetailDialog = true;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    getBeanCountInfo() {
      let url = this.beanCountUrl;
      this.$http
        .get(url)
        .then(
          function(resp) {
            console.info(resp);
            this.beanKindCount = resp.data.data.kinds;
            this.beanAllWeight = resp.data.data.stockSum;
            if (this.weight == "(g)") {
              this.beanAllWeight = this.weightTrans(this.beanAllWeight);
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      //.replace(/年|月/g, "-").replace(/日/g, " ")
      return this.$moment(date).format("YYYY-MM-DD");
    },
    weightTrans(val) {
      //把kg转换成g
      return val * 1000;
    },
    searchClick() {
      var active = 0;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      if (this.searchParamKey == "supply") {
        let params = {
          pageNum: this.beanPage.pageNum,
          pageSizez: this.beanPage.pageSize,
          supply: this.searchParamValue,
        };
        if (
          this.searchParamValue.trim().length > 0 &&
          this.searchParamValue != null
        ) {
          this.$http
            .get("/manage/bean/searchBySupply.do", { params: params })
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.beanList = resp.data.data.list;
                  this.beanPage.total = resp.data.data.total;

                  if (this.weight == "(g)") {
                    for (let index in this.beanList) {
                      this.beanList[index].stock = this.weightTrans(
                        this.beanList[index].stock
                      );
                    }
                  }

                  this.activeBeanId = resp.data.data.list[0].id;
                  console.info(resp.data.data.list[0]);
                  this.selectBean = this.beanList[0];
                  this.selectBean.owner = -1;
                  this.showReportList = true;
                  this.isAdd = false;
                  this.refreshBeanDetail = false;
                  // 在组件移除后，重新渲染组件
                  // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                  this.$nextTick(() => {
                    this.refreshBeanDetail = true;
                  });
                  this.beanDetailDialog = true;
                }
              }.bind(this)
            )
            .catch((err) => err);
        } else {
          this.getBeanList();
        }
      } else {
        let params = {
          pageNum: this.beanPage.pageNum,
          pageSizez: this.beanPage.pageSize,
          keyword: this.searchParamValue,
        };
        if (
          this.searchParamValue.trim().length > 0 &&
          this.searchParamValue != null
        ) {
          this.$http
            .get("/manage/bean/searchByName.do", { params: params })
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.beanList = resp.data.data.list;
                  this.beanPage.total = resp.data.data.total;

                  if (this.weight == "(g)") {
                    for (let index in this.beanList) {
                      this.beanList[index].stock = this.weightTrans(
                        this.beanList[index].stock
                      );
                    }
                  }

                  this.activeBeanId = resp.data.data.list[0].id;
                  console.info(resp.data.data.list[0]);
                  this.selectBean = this.beanList[0];
                  this.selectBean.owner = -1;
                  this.showReportList = true;
                  this.isAdd = false;
                  this.refreshBeanDetail = false;
                  // 在组件移除后，重新渲染组件
                  // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                  this.$nextTick(() => {
                    this.refreshBeanDetail = true;
                  });
                  this.beanDetailDialog = true;
                }
              }.bind(this)
            )
            .catch((err) => err);
        } else {
          this.getBeanList();
        }
      }
      this.active = active;
      this.dialogTableVisible = false;
      loading.close();
    },
    checkDevice(item) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //    background: "rgba(0, 0, 0, 0.7)",
      // });
      // this.loading = loading;
      this.activeBeanId = item.id;
      setTimeout(() => {
        loading.close();
      }, 2000);

      console.info(item);
      this.selectBean = item;
      this.selectBean.owner = -1;
      this.showReportList = true;
      this.refreshBeanDetail = false;
      this.isAdd = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshBeanDetail = true;
      });
      this.beanDetailDialog = true;
    },
    beanPageChange(val) {
      this.beanPage.pageNum = val;
      this.getBeanList();
    }
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.box-item .box-item-img img {
  width: 65px;
}
.box-content {
  gap: 15px;
}
.box-item{
  width: calc(50% - 10px) !important;
}
</style>
